import { request } from '@/utils/request'

// 登录参数接口
export interface LoginParams {
  username: string // 用户名
  password: string // 密码
}

// 登录响应接口
export interface LoginResponse {
  access_token: string // 访问令牌
  token_type: string // 令牌类型
  expires_in: number // 过期时间（秒）
}

/**
 * 用户登录
 * @param params 登录参数（用户名和密码）
 * @returns 登录令牌信息
 */
export const login = async (params: LoginParams) => {
  return request<LoginResponse>({
    url: '/v1/auth/access-tokens',
    method: 'POST',
    body: params,
    contentType: 'form', // 使用 form 格式发送数据
    skipAuthRedirect: true // 登录接口不需要重定向
  })
}
